<template>
    <div style="text-align: center;">
        <template v-if="hasPrice">
            <alveolus-quantity v-if="minOrder === 1" :tray-formats="trayFormats" @num-plants-changed="numPlantsChanged"
                               :tray-format-recommended-id="bpRecommendedTrayFormatId" :injerto="injerto" :seed-lost-percent="seedLostPercent">
            </alveolus-quantity>
            <alveolus-quantity-min-order v-else :tray-formats="trayFormats" @num-plants-changed="numPlantsChanged"
                                         :alveolus-quantity="seedsByAlveolus" :min-order-seeds="minOrder" :seed-lost-percent="seedLostPercent"
                                         :tray-format-recommended-id="bpRecommendedTrayFormatId" :injerto="injerto">
            </alveolus-quantity-min-order>
            <seeds-by-alveolus v-if="maxSeedsByAlveolus > 1"
                               v-model="seedsByAlveolusAux" :recommended="bpRecommendedSeedsByAlveolus"
                               :max-seeds-by-alveolus="maxSeedsByAlveolus"></seeds-by-alveolus>
            <summary-quantity :num-plants="numPlants" :seeds-by-alveolus="seedsByAlveolusAux" :tray-formats="trayFormats" :ahorro="ahorro"></summary-quantity>
            <quantity-select-totals :all-screens="totalsAllScreen" v-bind="quantitySelectTotalsBinds"
            ></quantity-select-totals>
            <back-varieties-min-order v-if="minOrder > 1" @click="clickBackVarietiesMinOrder"></back-varieties-min-order>
        </template>
        <template v-else>
            <no-price @choose-other-variety="$emit('choose-other-variety')"></no-price>
        </template>
    </div>
</template>

<script>
    import AlveolusQuantity from "./AlveolusQuantity";
    import AlveolusQuantityMinOrder from "./AlveolusQuantityMinOrder";
    import SeedsByAlveolus from "./SeedsByAlveolus";
    import SummaryQuantity from "./SummaryQuantity";
    import QuantitySelectTotals from "./QuantitySelectTotals";
    import BackVarietiesMinOrder from "./BackVarietiesMinOrder";
    import NoPrice from "./NoPrice";
    export default {
        name: "QuantitySelectEdit",
        components: {
            NoPrice,
            BackVarietiesMinOrder,
            QuantitySelectTotals, SummaryQuantity, SeedsByAlveolus, AlveolusQuantityMinOrder, AlveolusQuantity},
        props: {
            minOrder: {
                type: Number
            },
            trayFormatsData: {
                type: Array,
                default: []
            },
            seedLostPercent: {
                type: Number
            },
            seedPrice: {
                type: Number
            },
            trayPriceBase: {
                type: Number
            },
            hasPrice: {
                type: Boolean
            },
            bpRecommendedSeedsByAlveolus: {
                type: Number,
                default: 1
            },
            bpRecommendedTrayFormatId: {
                type: Number|String
            },
            maxSeedsByAlveolus: {
                type: Number,
                default: 30
            },
            seedsByAlveolus: {
                type: Number,
                default: 1
            },
            totalsAllScreen: {
                type: Boolean,
                default: false
            },
            injerto: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                numPlants: 0,
                seedsByAlveolusAux: 1,
                trayFormats: []
            }
        },
        computed: {
            validTrayFormats() {
                return this.trayFormats.filter(tf => tf.value > 0);
            },
            validTrayFormatsWithPrices() {
                let validTrayFormats = JSON.parse(JSON.stringify(this.validTrayFormats));
                validTrayFormats.forEach(tf => {
                    tf.trayPrice = this.trayPrice(tf);
                    tf.ahorro = this.ahorroByTray(tf);
                    tf.totalPrice = Math.round((tf.trayPrice / 1.1 - tf.ahorro) * 1.1 * 100) / 100;
                });
                return validTrayFormats;
            },
            ahorro() {
                let ahorro = 0;
                this.validTrayFormatsWithPrices.forEach(tf => {
                    ahorro += tf.ahorro * tf.value;
                });
                return ahorro;
            },
            price() {
                let price = 0;
                this.validTrayFormatsWithPrices.forEach(tf => {
                    price += tf.trayPrice * tf.value;
                });
                return price;
            },
            totalPrice() {
                return Math.round((this.price / 1.1 - this.ahorro) * 1.1 * 100) / 100;
            },
            totalSeedsPrice() {
                let seeds = 0;
                let seedsByAlveolus = this.seedsByAlveolus;
                if (this.minOrder > 1) {
                    seeds = this.numPlants * seedsByAlveolus;
                } else {
                    this.validTrayFormats.forEach(tf => {
                        seeds += tf.value * tf.unidades * seedsByAlveolus;
                    });
                }
                if (this.injerto) {
                    seeds = Math.ceil(seeds * 100 / (100 - this.seedLostPercent));
                }
                return seeds * this.seedPrice;
            },
            quantitySelectTotalsBinds() {
                return {
                    'tray-formats-with-prices': this.validTrayFormatsWithPrices,
                    'total-price': this.totalPrice,
                    'min-order': this.minOrder,
                    'tasa-ahorro': this.tasaAhorro,
                    'seeds-by-alveolus': this.seedsByAlveolus,
                }
            }
        },
        watch: {
            trayFormatsData() {
                this.setTrayFormatData();
            },
            seedsByAlveolus(value) {
                this.seedsByAlveolusChanged(value);
            },
            seedsByAlveolusAux(value) {
                this.$emit('update:seedsByAlveolus', value);
            },
            totalPrice(value) {
                this.$emit('total-price-changed', value);
            },
            minOrder(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.resetQuantities();
                }
            },
            hasPrice(newVal) {
                if (!newVal) {
                    this.resetQuantities();
                }
            },
            quantitySelectTotalsBinds() {
                this.$emit('quantity-select-totals-binds', this.quantitySelectTotalsBinds);
            }
        },
        methods: {
            numPlantsChanged(numPlants) {
                this.numPlants = numPlants;
                this.$emit('changed-num-plants', numPlants);
            },
            seedsByAlveolusChanged(value) {
                this.seedsByAlveolusAux = value;
            },
            setTrayFormatData() {
                let trayFormats = this.trayFormatsData;
                trayFormats.forEach(tf => {
                    if (tf.value === undefined) {
                        tf.value = 0;
                    }
                })
                this.trayFormats = trayFormats;
            },
            resetQuantities() {
                this.trayFormats.forEach(tf => {
                    tf.value = 0;
                });
                this.numPlants = 0;
                this.$emit('changed-num-plants', this.numPlants);
            },
            clickBackVarietiesMinOrder() {
                this.$emit('click-back-varieties-min-order');
            },
            trayPrice(trayFormat) {
                let price = this.trayPriceBase;
                if (this.minOrder > 1) {
                    price += this.totalSeedsPrice / trayFormat.value;
                } else {
                    let seedsNum = trayFormat.unidades * this.seedsByAlveolus;
                    if (this.injerto) {
                        seedsNum = Math.ceil(seedsNum * 100 / (100 - this.seedLostPercent));
                    }
                    price += seedsNum * this.seedPrice;
                }
                price = Math.round(price * 100) / 100;
                return price;
            },
            ahorroByTray(trayFormat) {
                let tasaAhorro = 0;
                let unidades = trayFormat.value;
                if (this.$root.tipo_cliente === 1) {
                    tasaAhorro = 0;
                } else if (unidades >= 12) {
                    tasaAhorro = 1;
                } else if (unidades >= 7) {
                    tasaAhorro = 0.66;
                } else if (unidades >= 3) {
                    tasaAhorro = 0.33;
                }
                return tasaAhorro;
            }
        },
        created() {
            this.setTrayFormatData();
            this.seedsByAlveolusChanged(this.seedsByAlveolus);
        }
    }
</script>

<style scoped>

</style>
